// Brand and business configuration for A1 Connect.
// Everything that would otherwise be hard-coded across the app lives here (or in the database).

export const BRAND = {
  name: "Athletes 1st",
  appName: "A1 Connect",
  clubName: "Athletes 1st Basketball Club",
  websiteUrl: "https://athletes1sttx.com",
  /** Public contact for families (receipts, waiver, refunds). Mailbox set up via Cloudflare Email Routing. */
  supportEmail: "support@athletes1sttx.com",
  colors: { black: "#080808", red: "#F20D2E", white: "#FFFFFF" },
} as const;

/**
 * Processing fee model. Parents pay the program price plus a fee that covers Stripe and the
 * platform; the coach receives the full program price. See ./lib/fees.ts.
 */
export const FEES = {
  /** Minimum platform (Okra) share of the base price, after Stripe's cost. */
  platformPct: 0.03,
  /** Stripe card pricing used to size the fee (the total is always computed at card rate). */
  stripeCardPct: 0.029,
  stripeCardFixedCents: 30,
  /** Stripe ACH pricing (only used to estimate Stripe's cost on ACH payments). */
  stripeAchPct: 0.008,
  stripeAchCapCents: 500,
  /** Totals are rounded up to a multiple of this amount. */
  roundToCents: 500,
} as const;

/** Sign-in options. Google stays off until the Google OAuth client is configured in Supabase. */
export const AUTH = {
  googleEnabled: import.meta.env.VITE_GOOGLE_AUTH_ENABLED === "true",
  minPasswordLength: 8,
} as const;

/** Runtime environment (Vite build-time variables). */
export const ENV = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  /** Only this host reports to Sentry (skips local dev and pages.dev previews). */
  productionHost: (import.meta.env.VITE_PRODUCTION_HOST as string | undefined) ?? "app.athletes1sttx.com",
} as const;
